// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-lines-2';

export const Component = () => (
  <path d='M23.563 2.922V21.6c0 .527-.192 1.005-.575 1.39a1.917 1.917 0 0 1-1.39.574H2.92a1.918 1.918 0 0 1-1.389-.575A1.917 1.917 0 0 1 .956 21.6V2.922c0-.527.192-1.006.575-1.39a1.917 1.917 0 0 1 1.39-.574h18.677c.527 0 1.006.191 1.39.575.383.383.575.862.575 1.389ZM21.599 0H2.921C2.107 0 1.437.287.861.862.288 1.436 0 2.107 0 2.922v18.677c0 .814.287 1.485.862 2.06.574.575 1.245.861 2.06.861h18.677c.814 0 1.485-.287 2.06-.861.575-.575.861-1.246.861-2.06V2.921c0-.814-.287-1.484-.861-2.06C23.084.288 22.413 0 21.599 0Zm-3.448 9.34H6.37c-.336 0-.48.143-.48.478 0 .335.144.479.48.479h11.78c.336 0 .48-.144.48-.479 0-.335-.144-.479-.48-.479Zm0 4.884H6.37c-.336 0-.48.144-.48.48 0 .334.144.478.48.478h11.78c.336 0 .48-.144.48-.479 0-.335-.144-.479-.48-.479Z' />
);

export const viewBox = '0 0 25 25';
